import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getLandingInfo } from '../../api/public';
import SectionTitle from './components/SectionTitle/SectionTitle';
import ReadMoreButton from './components/ReadMoreButton/ReadMoreButton';
import EmptyData from './components/EmptyData/EmptyData';
import VacancyCard from './components/VacancyCard/VacancyCard';
import WorkingProcess from './components/WorkingProcess/WorkingProcess';
import MainLayout from './components/MainLayout';
import SectionLayout from './components/SectionLayout';
import HeroSectionEmployees from './components/HeroSectionEmployees/HeroSectionEmployees';

export const Employees = () => {
  const [landingData, setLandingData] = useState({
    vacancies: [],
    internships: [],
    categories: [],
  });
  const { t, i18n } = useTranslation();

  useEffect(() => {
    getLandingInfo()
      .then(res => {
        const data = res?.data?.data;
        setLandingData({
          vacancies: data?.vacancies,
          internships: data?.internships,
          categories: data?.areas,
        });
      })
      .catch(err => {
        console.log(err);
      });
  }, [i18n.language]);
  const { vacancies, internships, categories } = landingData;

  return (
    <div className="d-flex flex-column">
      <main>
        <HeroSectionEmployees />
        {/*<HeroLayout variant="employers">*/}
        {/*  <div className="h-100 d-flex flex-column justify-content-between">*/}
        {/*    <div className={st.heroFlexContainer}>*/}
        {/*      <HeroInfo*/}
        {/*        title={t('heroDiscover')}*/}
        {/*        titleSecond={t('heroMoreThan')}*/}
        {/*        subtitle={t('heroDiscoverJobs')}*/}
        {/*        description={t('heroEmployeesDesc')}*/}
        {/*      />*/}
        {/*      <HeroIllustration type="employees" />*/}
        {/*    </div>*/}
        {/*    <CardStats />*/}
        {/*  </div>*/}
        {/*</HeroLayout>*/}

        <MainLayout>
          {/*Vacancies*/}
          <SectionLayout>
            <SectionTitle titleWord={t('actual')} accentTitleWord={t('vacancies')} />
            <div className="row">
              {vacancies.length > 0 && (
                <>
                  <VacancyCard actualData={vacancies} />
                  <ReadMoreButton link="/view/jobs" textBtn={t('showAllJobs')} />
                </>
              )}
              {vacancies.length === 0 && <EmptyData type="emptyVacancies" />}
            </div>
          </SectionLayout>
          <SectionLayout>
            <SectionTitle titleWord={t('actual')} accentTitleWord={t('internships')} />
            <div className="row mt-2">
              {internships.length > 0 && (
                <>
                  <VacancyCard actualData={internships} />

                  <ReadMoreButton link="/view/intern" textBtn={t('showAllIntern')} />
                </>
              )}
              {internships.length === 0 && <EmptyData type="emptyInternships" />}
            </div>
          </SectionLayout>
          {/*Working process*/}
          <SectionLayout>
            <SectionTitle titleWord={t('howToWork')} accentTitleWord={t('organization')} />
            <WorkingProcess type="employeesLandingPage" />
          </SectionLayout>
          {/*Category*/}
          {/*<SectionLayout>*/}
          {/*  <div className="row mt-2">*/}
          {/*    <SectionTitle titleWord={t('explore')} accentTitleWord={t('category')} />*/}
          {/*    {categories.length > 0 && <ExploreCategory areas={categories} />}*/}
          {/*    {categories.length === 0 && <EmptyData type="emptyCategory" />}*/}
          {/*  </div>*/}
          {/*</SectionLayout>*/}
        </MainLayout>
      </main>
    </div>
  );
};
